var g_devtricker_password_strength = 0;

async function devtricker_process_creteAccount(form) {
    try {
        devtricker_dom_set_hideAccountCreationErrorMessage();
        devtricker_dom_set_changeCreateAccountButtonToLoading();

        await devtricker_ajax_post_createAccount(form);
        await devtricker_ajax_post_customWpLogin(form);
        window.location.reload();

    } catch (error) {
        devtricker_dom_set_accountCreationErrorMessage(g_devtricker_i18n.account_creation_error_1);
        devtricker_dom_set_changeCreateAccountButtonToOriginal();
    }
}

async function devtricker_process_validateUsername(input) {

    const username = input.value.trim();

    if (username.length === 0) {
        return;
    }

    let availability = await devtricker_ajax_post_isTheUsernameAvailable(username);

    if (availability.available) {
        devtricker_dom_set_changeCreateAccountInputToSuccess(input);
    } else {
        devtricker_dom_set_changeCreateAccountInputToFail(input, availability.message);
    }

    devtricker_checkFormValidityCreationAccount();
}

async function devtricker_process_validateEmail(input) {
    const email = input.value.trim();

    if (email.length === 0) {
        return;
    }

    if (!devtricker_validateEmail(email)) {
        let message = g_devtricker_i18n.account_creation_error_2;

        devtricker_log(null, devtricker_log_level.INFO, message);

        devtricker_dom_set_changeCreateAccountInputToFail(input, message);
        return;
    }

    let availability = await devtricker_ajax_post_isTheEmailAvailable(email);

    if (availability.available) {
        devtricker_dom_set_changeCreateAccountInputToSuccess(input);
    } else {
        devtricker_dom_set_changeCreateAccountInputToFail(input, availability.message);
    }

    devtricker_checkFormValidityCreationAccount();
}

async function devtricker_process_validateFullname(input) {
    const fullname = input.value.trim();

    if (fullname.length === 0) {
        return;
    }

    let validation = devtricker_isValidFullName(fullname);

    if (!validation.valid) {
        devtricker_log(null, devtricker_log_level.INFO, validation.message);

        devtricker_dom_set_changeCreateAccountInputToFail(input, validation.message);
        return;
    }

    if (validation.valid) {
        devtricker_dom_set_changeCreateAccountInputToSuccess(input);
    } else {
        devtricker_dom_set_changeCreateAccountInputToFail(input, validation.message);
    }

    devtricker_checkFormValidityCreationAccount();
}

function devtricker_validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function devtricker_isValidFullName(name) {
    name = name.trim();

    if (!/^[\p{L}\s]+$/u.test(name)) {
        return {
            valid: false,
            message: g_devtricker_i18n.account_creation_error_3
        };
    }

    if (name.length < 1 || name.length > 32) {
        return {
            valid: false,
            message: g_devtricker_i18n.account_creation_error_4
        };
    }

    return {
        valid: true,
        message: 'Name is valid.'
    };
}

function devtricker_process_validatePassword(input) {
    var password = input.value;
    var strengthBars = document.querySelectorAll('.strength-bar');
    
    strengthBars.forEach(bar => {
        bar.className = 'strength-bar';
    });

    if (!password) {
        g_devtricker_password_strength = 0;
        return;
    }

    if (typeof zxcvbn !== 'function') {
        console.error('zxcvbn not loaded');
        return;
    }

    var result = zxcvbn(password);
    g_devtricker_password_strength = result.score;
    
    strengthBars.forEach((bar, index) => {
        if (index <= result.score) {
            if (result.score <= 1) {
                bar.classList.add('weak');
            } else if (result.score <= 2) {
                bar.classList.add('medium');
            } else {
                bar.classList.add('strong');
            }
        }
    });

    devtricker_checkFormValidityCreationAccount();
}

function devtricker_checkFormValidityCreationAccount() {
    const usernameValid = document.getElementById('signup-form-username').classList.contains('is-valid');
    const emailValid = document.getElementById('signup-form-email').classList.contains('is-valid');
    const fullnameValid = document.getElementById('signup-form-fullname').classList.contains('is-valid');
    const passwordValid = g_devtricker_password_strength >= 2;

    document.getElementById('create-account-button').disabled = !(usernameValid && emailValid && fullnameValid && passwordValid);
}